import { render, staticRenderFns } from "./CPOpenAccountFormProse.vue?vue&type=template&id=cb7399d0&scoped=true&"
var script = {}
import style0 from "./CPOpenAccountFormProse.vue?vue&type=style&index=0&id=cb7399d0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7399d0",
  null
  
)

export default component.exports